import { jsx } from "react/jsx-runtime";
import LinkIcon from "@mui/icons-material/Link";
import { validateTidalLicense } from "../../base/index.js";
function Link(props) {
  return /* @__PURE__ */ jsx(
    LinkIcon,
    {
      "data-testid": "Link",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Link",
      "data-tidal-icon-meta": "editing,attachment"
    }
  );
}
Link.tidalIconMeta = {
  categories: "editing,attachment",
  name: "Link"
};
validateTidalLicense();
export {
  Link
};
//# sourceMappingURL=Link.js.map
